import { render, staticRenderFns } from "./InvoiceVersionsSection.vue?vue&type=template&id=a27ee77e&scoped=true&"
import script from "./InvoiceVersionsSection.vue?vue&type=script&lang=js&"
export * from "./InvoiceVersionsSection.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceVersionsSection.vue?vue&type=style&index=0&id=a27ee77e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27ee77e",
  null
  
)

export default component.exports